$w.onReady(() => {
	waitForLoading();
});

export function button6_onClick() {
	$w('#columnStrip2').show();
	waitForLoading();
}
